import Velocity from 'velocity-animate';

export class SsGhost {
  constructor ( elm ) {
    this.elm = elm;
  }

  velocity ( param ) {
    return new Promise ( ( resolve ) => {
      const defs = {
        duration: 300,
        easing: 'easeInOutSine',
        complete: () => { resolve(); },
      };
      Velocity( this.elm, param.prop, Object.assign( defs, param.opt ) );
    });
  }
}
